/* TODO:
 -Session ID and token in cookies.  Need some sort of unique identifier.
 -Correct handling of invalid session messages
 */
(function (global, factory) {
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		module.exports = factory(global, true);
	} else {
		factory(global);
	}
})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {

	function TSService(options) {
		let app		  = this,
			opt		  = { handlers: {} },
			reqID		= 0,
			queue		= [],
			connecting   = false,
			connected	= false,
			connection   = null,
			connPromise  = null,
			sessionID	= null,
			authToken	= null,
			debug		= true,
			openTimeout  = 5000;

		let openWait = null;


		let handlers = {
			'auth': function (result) {
				log(result.msg);

				if ( result.status === 200 ) {
					sessionID = result.payload.session;
					authToken = result.payload.token;
					return true;
				}

				return false;
			},
			'resumeSession': function (result) {
				log(result.msg);

				if ( result.status === 200 ) {
					sessionID = result.payload.session;
					authToken = result.payload.token;
					return true;
				}

				sessionID = null;
				authToken = null;
				return false;
			},
			'sessionTimeout': function (result) {
				sessionID = false;
				authToken = false;
				connection = null;
				connecting = false;

				if ( connected && connection ) {
					connection.close();
				}
			},
			'socketTimeout': function (result) {
				if ( connected && connection ) {
					connection.close();
				}

				connected = false;
				connecting = false;
			},
		};


		function processQueue() {
			if ( !ready() ) {
				return false;
			}

			for ( let index in queue ) {
				queue[ index ].req.session = sessionID;
				queue[ index ].req.token = authToken;
				connection.send(JSON.stringify(queue[ index ].req));
			}
		}



		function rejector(err) {
			console.error(err);
			return Promise.reject(err);
		}



		function ready() {
			return connected;
		}



		function connect() {
			if ( connected && !connecting && connPromise ) {
				return connPromise;
			}
			connecting = true;
			connection = new WebSocket(opt.url);

			connPromise = promise();
			bindListeners();

			openWait = setTimeout(function () {
				if ( connecting && !connected ) {
					if ( opt.handlers.hasOwnProperty('_onConnectionTimeout') ) {
						opt.handlers._onConnectionTimeout.call(null, '');
					}

					connection.close();
				}
				clearTimeout(openWait);
			}, openTimeout);

			return connPromise.promise;
		}



		function bindListeners() {
			connection.addEventListener('open', function (e) {
				log('TS Service Connection Established');
				connecting = false;
				connected = true;
				connPromise.resolve();

				if ( opt.handlers.hasOwnProperty('_onOpen') ) {
					opt.handlers._onOpen.call(null, '');
				}
			});

			// Close
			connection.addEventListener('close', function (e) {
				connected = false;

				log('TS Service Connection Closed.');

				if ( opt.handlers.hasOwnProperty('_onClose') ) {
					opt.handlers._onClose.call(null, '');
				}
			});

			// Error
			connection.addEventListener('error', function (e) {
				log('WebSocket Error:', e);
				connection.close();
				//connect();

				if ( opt.handlers.hasOwnProperty('_onError') ) {
					opt.handlers._onError.call(null, '');
				}
			});

			// Receiving messages
			connection.addEventListener('message', function (e) {
				let msg = JSON.parse(e.data);
				log('RECEIVED:', msg);

				if ( handlers.hasOwnProperty(msg.type) ) {
					handlers[ msg.type ].call(app, msg);
				}

				if ( opt.handlers.hasOwnProperty(msg.type) ) {
					opt.handlers[ msg.type ].call(null, msg);
				}

				if ( opt.handlers.hasOwnProperty('_onMessage') ) {
					opt.handlers._onMessage.call(null, '');
				}

				if ( msg.hasOwnProperty('reqID') && typeof msg.reqID === 'number' ) {
					let time = ((Date.now() - queue[ msg.reqID ].start) / 1000).toFixed(3);
					if ( msg.status === 200 ) {
						queue[ msg.reqID ].promise.resolve(msg);

						log('RESOLVED REQID', msg.reqID, 'IN', `${time}s`);
					} else {
						queue[ msg.reqID ].promise.reject(msg);
						log('REJECTED REQID', msg.reqID, 'IN', `${time}s`);
					}

					delete (queue[ msg.reqID ]);
				}
			});
		}

		/*ignore jslint start*/
		this.addHandler = function (name, handler) {
			opt.handlers[ name ] = handler;
		};


		this.removeHandler = function (name) {
			opt.handlers[ name ] = null;
			delete (opt.handlers[ name ]);
		};

		/*ignore jslint end*/


		function send(data) {
			queue.push({
				promise: promise(),
				req: data,
				start: Date.now(),
			});

			if ( connected ) {
				log('SENDING:', data);
				connection.send(JSON.stringify(data));
			} else {
				log('QUEUEING:', data);
			}

			return queue[ data.reqID ].promise.promise;
		}



		function getBaseRequest(type, payload) {
			let req = {
				reqID: reqID++,
				type: type,
				payload: payload,
			};

			if ( sessionID ) {
				req.session = sessionID;
			}

			if ( authToken ) {
				req.token = authToken;
			}

			return req;
		}



		function promise() {
			let p = {};
			let promise = new Promise(function (resolve, reject) {
				p.resolve = resolve;
				p.reject = reject;
			});

			p.then = promise.then.bind(promise);
			p.catch = promise.catch.bind(promise);
			p.promise = promise;

			return p;
		}



		function log() {
			if ( !debug ) return true;
			Function.apply.call(console.log, console, Array.prototype.slice.call(arguments));
		}



		function init() {
			opt = options;
			if ( !opt.hasOwnProperty('handlers') ) {
				opt.handlers = {};
			}

			if ( !opt.url ) {
				return rejector('url must be provided to connect');
			}

			if ( ready() ) {
				return Promise.resolve(true);
			}

			return connect()
				.then(function (res) {
					processQueue();
					return Promise.resolve(res);
				})
				.catch(rejector);
		}



		this.send = function (type, payload) {
			if ( !type ) {
				throw new Error('send: type is required');
			}

			if ( !payload ) payload = {};

			if ( !ready() ) {
				console.error('Connection not ready.');
				init(opt);
			}

			return send(getBaseRequest(type, payload));
		};



		this.close = function () {
			sessionID = null;
			authToken = null;
			connected = false;

			if ( connection ) {
				connection.close();
			}
		};

		this.sessionSet = function (session, token) {
			sessionID = session;
			authToken = token;

			return send(getBaseRequest('resumeSession', {}), {});
		};

		init();
	}



	if ( !noGlobal ) window.TSService = TSService;
	return TSService;
});


// WEBPACK FOOTER //
// ./src/svc/service-connector.js